import type {RoomID} from './types';
import {ClientCallType} from './clientCallType';

export const backoffBaseOptions = {min: 100, max: 30_000, jitter: 0.2};
export const NONE = 'none';
export const SDP_OFFER_IGNORED = 'offer_ignored';
export const APPLICATION_JSON = 'application/json';
export const MAX_RECONNECT_ATTEMPTS = 8;
export const GUID_MIN_LENGTH = 1;
export const MAIN_ROOM_ID: RoomID = 'main';
export const DEFAULT_BUFFER_SIZE = 50;
export const DEFAULT_CLIENT_CALLTYPE = ClientCallType.AudioVideoPresentation;
